<template>
  <div
    style="height: 500px;"
  >
    <LoadingModal
      :show="true"
      :sucesso="false"
      texto="Enviando a solicitação. Por favor aguarde…"
    />
  </div>
</template>
<script>

import LoadingModal from '@/components/LoadingModal/LoadingModal'

export default {
  name: 'TemplateStepFinalizar',
  components: { LoadingModal }
}
</script>
<style scoped>
</style>
